// Stats.js
import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import Sidebar from "../components/Sidebar";

const Stats = () => {
  const [stats, setStats] = useState({ bestSelling: "", worstSelling: "", stagnantProducts: [] });

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/axios/stats`)
      .then(response => setStats(response.data))
      .catch(error => console.error("Error al obtener estadísticas:", error));
  }, []);

  return (
    <div className="flex">
      <div className="flex-1 p-6 ml-64">
        <h1 className="text-3xl font-bold mb-4">Estadísticas de la Tienda</h1>
        <p className="text-lg">📈 Producto más vendido: <b>{stats.bestSelling || "N/A"}</b></p>
        <p className="text-lg">📉 Producto menos vendido: <b>{stats.worstSelling || "N/A"}</b></p>
        <p className="text-lg">⏳ Productos sin ventas: <b>{stats.stagnantProducts.length}</b></p>
      </div>
    </div>
  );
};

export default Stats;
